import React from 'react'
import {UseFormReturn, useWatch} from 'react-hook-form'

import {NewAssetStandardOperationTimeData} from '../../../types'
import {StandardOperationTime} from '../../../types/standardOperationTimes'

import {NextOccurencesPreview} from './NextOccurencesPreview'

type EditDialogNextOccurencesPreviewProps = {
  isValid: boolean
} & Pick<UseFormReturn<NewAssetStandardOperationTimeData>, 'control'>

export const EditDialogNextOccurencesPreview: React.FC<EditDialogNextOccurencesPreviewProps> = ({
  isValid,
  control
}) => {
  const standardOperationTime = useWatch({control})
  if (!standardOperationTime || !standardOperationTime.calendarEvent || !isValid) {
    return null
  }
  const event: StandardOperationTime = standardOperationTime.calendarEvent as StandardOperationTime
  return <NextOccurencesPreview standardOperationTime={event} />
}
